const HotJarEventEnum = {
  LOGIN            : 'identify',
  STATE_CHANGE     : 'stateChange',
  VIRTUAL_PAGE_VIEW: 'vpv'
}

export default HotJarEventEnum
